module.exports = __webpack_public_path__ + "img/2.be0ab5bf.jpg";